import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {StartedEntryComponent} from "./started-entry/started-entry.component";
import {StartedPickComponent} from "./started-pick/started-pick.component";
import {StartedDownloadsComponent} from "./started-downloads/started-downloads.component";
import {StartedCreateComponent} from "./started-create/started-create.component";
import {StartedTemplateComponent} from "./started-template/started-template.component";

export const routes: Routes = [
  {
    path: '', component: StartedEntryComponent,
    children: [
      {path: 'pick', component: StartedPickComponent},
      {path: 'pick/:mode', component: StartedPickComponent},
      {path: 'create', component: StartedCreateComponent},
      {path: 'create/:mode', component: StartedCreateComponent},
      {path: 'downloads', component: StartedDownloadsComponent},
      {path: 'downloads/:id', component: StartedDownloadsComponent},
      {path: 'downloads/ent/:eri', component: StartedDownloadsComponent, data: {showHeader: false, showBack: false, title: 'Download'}},
      {path: 'template', component: StartedTemplateComponent},
      {path: 'template/:mode', component: StartedTemplateComponent}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StartedRoutingModule {
}
